import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-title',
  templateUrl: './simple-title.component.html',
  styleUrls: ['./simple-title.component.scss']
})
export class SimpleTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
